import { RankedCareer } from "../results-page";
import type { Question, Answer } from "../types/quiz";

declare global {
  interface Window {
    digitalData: any;
  }
}

const stripHTML = (str: string): string => {
  return str.replace(/<[^>]*>/g, "");
};

const initializeDigitalData = (): void => {
  if (typeof window !== "undefined") {
    if (!window.digitalData) {
      window.digitalData = {};
    }

    if (!window.digitalData.page) {
      window.digitalData.page = {};
    }

    if (!window.digitalData.page.careerQuiz) {
      window.digitalData.page.careerQuiz = {};
    }
  }
};

export const trackStart = (): void => {
  try {
    initializeDigitalData();
    window.digitalData.page.careerQuiz["status"] = "started";
  } catch (e) {
    console.error(e);
  }
};

export const trackCompleteStep = (
  currentQuestionId: number | undefined,
  questions: Question[],
  answer: Answer,
  timeSpent?: number,
): void => {
  try {
    initializeDigitalData();

    const currentQuestion = questions.find(
      (q: Question) => q.id === currentQuestionId
    );

    if (currentQuestion) {
      let answers;

      switch (currentQuestion.type) {
        case "scale":
          const answerIndex = answer.value ? answer.value - 1 : 0;
          answers = currentQuestion.scale.options[answerIndex];
          break;
        case "multiple_choice":
          answers = currentQuestion.options[answer.chosenIndex ?? 0].text;
          break;
        case "multiple_select":
          if (Array.isArray(answer?.chosenIndices)) {
            answers = answer.chosenIndices.map(
              (a) => currentQuestion.options[a].text
            );
          }
          break;
        case "ranking":
          if (Array.isArray(answer?.rankOrder)) {
            answers = answer.rankOrder.map(
              (a) => currentQuestion.options[a].text
            );
          }
          break;
        default:
      }

      window.digitalData.page.careerQuiz[`question_${currentQuestion.id}`] = {
        questionId: currentQuestion.id,
        timeSpent,
        question: stripHTML(currentQuestion.question),
        answers,
        event: "completed_question",
      };
      window.digitalData.page.careerQuiz["totalTimeSpent"] =
        (window.digitalData.page.careerQuiz["totalTimeSpent"] || 0) +
        (timeSpent || 0);
    }
  } catch (e) {
    console.error(e);
  }
};

export const trackComplete = (rankedCareers: RankedCareer[]): void => {
  try {
    initializeDigitalData();
    window.digitalData.page.careerQuiz["status"] = "completed";
    window.digitalData.page.careerQuiz["final_result"] = rankedCareers[0].name;
  } catch (e) {
    console.error(e);
  }
};

export const trackLinkClick = (label: string, url: string): void => {
  try {
    initializeDigitalData();

    if (!window.digitalData.page.careerQuiz.events) {
      window.digitalData.page.careerQuiz.events = [];
    }

    window.digitalData.page.careerQuiz.events.push({
      eventName: "link_clicked",
      label,
      url,
    });
  } catch (e) {
    console.error(e);
  }
};
